import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalUserPage from '../../../../../stores/global-user-page';
import { RequestRateStatus } from '../../../../../api/types/lecturers/price-rate/request-rate/request-rate-status';
import { BranchLecturerRateEntity } from '../../../../../api/types/lecturers/user-details-lecturer';

export const updateRateStatus = async (
  branchId: number,
  userId: number,
  rateId: number,
  isApprove: boolean,
) => {
  try {
    // TODO API call
    const res = await appApi.updateRequestRateStatus(
      branchId,
      userId,
      isApprove,
      rateId,
    );

    const updatedRate: BranchLecturerRateEntity = res.data.body;

    // TODO update the state:
    const updateStatus = isApprove
      ? RequestRateStatus.Approved
      : RequestRateStatus.Denied;

    if (globalUserPage.lecturerDetails) {
      globalUserPage.lecturerDetails.rates3 =
        globalUserPage.lecturerDetails.rates3.map((group) => ({
          ...group,
          rates: group.rates.map((rate) =>
            rate.id === updatedRate.id ? updatedRate : rate,
          ),
        }));
    }
    toast.success('הפעולה בוצעה בהצלחה');
  } catch (e) {
    toast.error('הבקשה נכשלה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(`updateRateStatus is failed with the error: ${e}`);
  }
};
